import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  key: 0,
  class: "card-body"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "table table-striped table-hover" }
const _hoisted_6 = { scope: "col" }
const _hoisted_7 = { scope: "col" }
const _hoisted_8 = { scope: "col" }
const _hoisted_9 = { scope: "col" }
const _hoisted_10 = { scope: "row" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = { class: "btn-group float-end" }
const _hoisted_14 = {
  key: 1,
  class: "card-body"
}
const _hoisted_15 = { class: "card mb-3" }
const _hoisted_16 = { class: "card-header" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-triangle-exclamation" }, null, -1)
const _hoisted_18 = { class: "card-body" }

import Layout from '@/components/Layout.vue';
import Navigation from '@/components/Navigation.vue';
import {onBeforeMount, ref} from "vue";
import {useHasActiveTest} from "@/hooks/hastest.hook";
import {WorkModel} from "@/models/work.model";
import {MainService} from "@/services/main.service";
import {AlertManager} from "@/services/alert.manager";
import {useLogout} from "@/hooks/logout.hook";
import {useTranslate} from "@/hooks/translate.hook";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultView',
  setup(__props) {

const hasTest = useHasActiveTest()
const logout = useLogout()
const t = useTranslate();
onBeforeMount(() => hasTest())

const results = ref<WorkModel[]>()
MainService.getLatestStudentResults().then(rsp => {
  results.value = rsp.data
}).catch(e => {
  AlertManager.error('Нисмо успели да учитамо резултате')
  logout()
})

function formatDate(timestamp: string) {
  if (timestamp == null) return 'N/A'
  return new Date(timestamp).toLocaleString('sr', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

function calcPoints(result: WorkModel) {
  const points = ((result.numberOfCorrectQuestions ?? 0) / result.numberOfQuestions) * result.maxPoints
  return Math.round(points * 100) / 100
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navigation),
    _createVNode(Layout, null, {
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(t)("page.results.card.title")), 1),
          (results.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (results.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("h5", null, _toDisplayString(_unref(t)("page.results.card.text")), 1),
                      _createElementVNode("table", _hoisted_5, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t)("page.results.card.table.subject")), 1),
                            _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(t)("page.results.card.table.test")), 1),
                            _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(t)("page.results.card.table.date")), 1),
                            _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(t)("page.results.card.table.result")), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (result) => {
                            return (_openBlock(), _createElementBlock("tr", null, [
                              _createElementVNode("th", _hoisted_10, _toDisplayString(result.test.subject!.title), 1),
                              _createElementVNode("td", null, _toDisplayString(result.test.title), 1),
                              _createElementVNode("td", null, _toDisplayString(formatDate(result.finishedAt!)), 1),
                              _createElementVNode("td", null, _toDisplayString(calcPoints(result)) + "/" + _toDisplayString(result.maxPoints), 1)
                            ]))
                          }), 256))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)("page.results.card.alt")), 1)
                    ])),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_RouterLink, {
                    to: "/list",
                    class: "btn btn-sm btn-secondary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("page.results.card.button")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)("page.results.card.loading")), 1))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h5", _hoisted_16, [
            _hoisted_17,
            _createTextVNode(" " + _toDisplayString(_unref(t)("page.results.note.title")), 1)
          ]),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)("page.results.note.text")), 1)
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})